export const DEFAULT_LANGUAGE = "ru";

export const normalizeLanguageCode = (language, fallback = DEFAULT_LANGUAGE) => {
  const value = String(language || "").trim().toLowerCase();

  if (value === "ua" || value.startsWith("uk")) {
    return "uk";
  }

  if (value.startsWith("ru")) {
    return "ru";
  }

  return fallback;
};

export const getStoredLanguage = (fallback = DEFAULT_LANGUAGE) => {
  try {
    return normalizeLanguageCode(localStorage.getItem("language"), fallback);
  } catch {
    return fallback;
  }
};

export const resolveInitialLanguage = (fallback = DEFAULT_LANGUAGE) => {
  const storedLanguage = getStoredLanguage("");

  if (storedLanguage) {
    return storedLanguage;
  }

  if (typeof navigator !== "undefined") {
    return normalizeLanguageCode(navigator.language, fallback);
  }

  return fallback;
};

export const isUkrainianLanguage = (language) =>
  normalizeLanguageCode(language) === "uk";
